import { StablecoinWorkflowPaymentType } from '../../models/workflow.model';
import { StablecoinApprovalDecisionValue } from '../../models/transfer.model';
import { StablecoinDepositInstructionCreate } from '../../models/deposit-instruction.model';

export class InitStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] InitStablecoinWalletsState';
}

export class ClearStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] ClearStablecoinWalletsState';
}

export class ResetStablecoinWalletsState {
	static readonly type: string = '[StablecoinWallets] ResetStablecoinWalletsState';
}

export class GetStablecoinWallets {
	static readonly type: string = '[StablecoinWallets] GetStablecoinWallets';
	constructor(public refresh?: boolean) {}
}

export class GetStablecoinWalletBalances {
	static readonly type: string = '[StablecoinWallets] GetStablecoinWalletBalances';
	constructor(public accountId: string) {}
}

export class GetStablecoinBalanceHistory {
	static readonly type: string = '[StablecoinWallets] GetStablecoinBalanceHistory';
	constructor(
		public days: number,
		public accountId?: string
	) {}
}

export class GetStablecoinDepositInstructions {
	static readonly type: string = '[StablecoinWallets] GetStablecoinDepositInstructions';
	constructor(public accountId: string) {}
}

export class CreateStablecoinDepositInstructions {
	static readonly type: string = '[StablecoinWallets] CreateStablecoinDepositInstructions';
	constructor(public body: StablecoinDepositInstructionCreate) {}
}

export class SetStablecoinAccountPaymentType {
	static readonly type: string = '[StablecoinWallets] SetStablecoinAccountPaymentType';
	constructor(
		public accountId: string,
		public paymentType: StablecoinWorkflowPaymentType,
		public enabled: boolean
	) {}
}

export class DecideStablecoinAccountPaymentType {
	static readonly type: string = '[StablecoinWallets] DecideStablecoinAccountPaymentType';
	constructor(
		public accountId: string,
		public paymentType: StablecoinWorkflowPaymentType,
		public decision: StablecoinApprovalDecisionValue
	) {}
}

export class SetStablecoinAccountOnchainAccount {
	static readonly type: string = '[StablecoinWallets] SetStablecoinAccountOnchainAccount';
	constructor(
		public accountId: string,
		public onchainAccountId: string | null
	) {}
}

export class GetStablecoinAccountFunding {
	static readonly type: string = '[StablecoinWallets] GetStablecoinAccountFunding';
	constructor(public accountId: string) {}
}
